export const SET_CARD_TRANSFER_DATA = 'SAVE_CARD_TRANSFER_DATA';
export const SET_CREDIT_TRANSFER_DATA = 'SAVE_CREDIT_TRANSFER_DATA';
export const SET_DEPOSIT_TRANSFER_DATA = 'SAVE_DEPOSIT_TRANSFER_DATA';
export const SET_BANK_TRANSFER_TYPE = 'SAVE_BANK_TRANSFER_TYPE';
